import { PropsWithChildren, useMemo, useState } from 'react';

import BrowserOutdatedBanner from 'src/components/browserOutdatedBanner/BrowserOutdatedBanner';
import { GlobalBannerContextProvider } from 'src/util/GlobalBannerContext';
import isBrowserSupported from 'src/util/supportedBrowser';

export default function BrowserOutdatedBannerWrapper({ children }: PropsWithChildren<{}>) {
  const supportedBrowser = useMemo(() => isBrowserSupported(), []);
  const [closed, setClosed] = useState(false);

  const banner =
    supportedBrowser || closed ? undefined : (
      <BrowserOutdatedBanner onRequestClose={() => setClosed(true)} />
    );
  return <GlobalBannerContextProvider banner={banner}>{children}</GlobalBannerContextProvider>;
}
